<template>
  <section class="pageInner">
    <header>
      <h1>Sua negociação foi efetivada com sucesso</h1>
      <p>Atenção aos detalhes abaixo.</p>
    </header>

    <div v-if="proposta">
      <!-- ENTRADA -->
      <div v-if="isEntradaPix" class="pix-wrap">
        <header>
          <h4>Entrada</h4>
          <p>Use o PIX abaixo para pagar sua entrada</p>
        </header>

        <template v-if="pixEntrada">
          <div class="qr">
            <vue-qrcode
              :value="pixEntrada"
              :options="{ width: qrSize, color: { dark: '#444' } }"
            />
          </div>
          <span class="codeWrap" @click.prevent="copiarCodigo(pixEntrada)">{{ pixEntrada }}</span>
          <p>Esta parcela será baixada automaticamente após a confirmação do pagamento</p>
        </template>

        <template v-else>
          <fa :icon="['fas','triangle-exclamation']" />
          <h4>Ops. Não foi possível obter o código PIX agora</h4>
          <a href="#" class="btn btn-success-2" @click.prevent="recarregarPix('entrada')">Tentar novamente</a>
        </template>
      </div>

      <div v-else-if="formaEntrada === 'cartao'">
        <header>
          <h4>Entrada</h4>
          <p>Sua entrada foi paga no cartão de crédito</p>
        </header>
      </div>

      <div v-else-if="formaEntrada === 'boleto'">
        <header>
          <h4>Entrada</h4>
          <p>Seus boletos foram gerados. Lembre-se de pagá-los até as datas de vencimento</p>
        </header>
      </div>

      <!-- PARCELAS -->
      <div v-if="isParcelasPix" class="pix-wrap parcelas">
        <header>
          <h4>Parcelas</h4>
          <p>Use o PIX abaixo para pagar as parcelas</p>
        </header>

        <template v-if="pixParcelas">
          <div class="qr">
            <vue-qrcode
              :value="pixParcelas"
              :options="{ width: qrSize, color: { dark: '#444' } }"
            />
          </div>
          <span class="codeWrap" @click.prevent="copiarCodigo(pixParcelas)">{{ pixParcelas }}</span>
          <p>As parcelas serão baixadas automaticamente após a confirmação do pagamento</p>
        </template>

        <template v-else>
          <fa :icon="['fas','triangle-exclamation']" />
          <h4>Ops. Não foi possível obter o código PIX agora</h4>
          <a href="#" class="btn btn-success-2" @click.prevent="recarregarPix('parcelas')">Tentar novamente</a>
        </template>
      </div>

      <div v-else-if="formaParcelas === 'cartao'" class="parcelas">
        <header>
          <h4>Parcelas</h4>
          <h5>Suas parcelas foram pagas com cartão de crédito. Você não precisa mais se preocupar</h5>
        </header>
      </div>

      <div v-else-if="formaParcelas === 'boleto'" class="parcelas">
        <header>
          <h4>Parcelas</h4>
          <h5>Suas parcelas foram geradas. Lembre-se de pagar os boletos até as datas de vencimento</h5>
        </header>
      </div>
    </div>
  </section>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'
import NegociaService from '@/services/negocieja.service.js'

export default {
  components: {
    VueQrcode
  },
  props: {
    session: {
      type: String
    },
    step: {
      type: String
    },
    steps: {
      type: Array
    },
    debitos: {
      type: Object
    }
  },
  data () {
    return {
      proposta: null,
      qrSize: 240
    }
  },
  
  computed: {
    idNegocieJaProposta () {
      return this.proposta?.proposta?.idNegocieJaProposta
        || this.proposta?.idNegocieJaProposta
        || this.proposta?.proposta?.jsonProposta?.meta?.idNegocieJaProposta
        || null
    },
    formaEntrada () {
      return this.proposta?.proposta?.jsonProposta?.debitos?.formaPagamentoEntrada || null
    },
    formaParcelas () {
      return this.proposta?.proposta?.jsonProposta?.debitos?.formaPagamentoParcelas || null
    },
    isEntradaPix () {
      return this.formaEntrada === 'pix'
    },
    isParcelasPix () {
      return this.formaParcelas === 'pix'
    },
    pixEntrada () {
      return this.pickPixCode('entrada')
    },
    pixParcelas () {
      return this.pickPixCode('parcelas')
    }
  },
  mounted () {
    this.$store.dispatch('negocieja/get').then(response => {
      this.proposta = response
      this.updateQrSize()
      window.addEventListener('resize', this.updateQrSize)
    })
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.updateQrSize)
  },
  methods: {
    updateQrSize () {
      this.qrSize = window.innerWidth < 689 ? (window.innerWidth - 120) : 240
    },
    pickPixCode (escopo) {
      const ck = this.proposta?.checkout || {}

      if (escopo === 'entrada') {
        const e = ck.entrada || {}
        return e.qrCodePix || e.emv || e.pix?.emv || e.pixCopiaCola
          || ck.qrCodePix || ck.emv || ck.pix?.emv || ck.pixCopiaCola || null
      }

      if (escopo === 'parcelas') {
        const p = ck.parcelas || {}
        return p.qrCodePix || p.emv || p.pix?.emv || p.pixCopiaCola
          || ck.qrCodePixParcelas || ck.emvParcelas
          || ck.qrCodePix || ck.emv || ck.pix?.emv || ck.pixCopiaCola || null
      }

      return ck.qrCodePix || ck.emv || ck.pix?.emv || ck.pixCopiaCola || null
    },
    async recarregarPix (escopo) {
      if (!this.idNegocieJaProposta) {
        window.toaster.emit('open', { style: 'warning', message: 'Proposta não identificada para gerar o PIX', floater: true })
        return
      }

      try {
        window.spinner.emit('open')

        const res = await NegociaService.gerarPix({
          idNegocieJaProposta: this.idNegocieJaProposta,
          tipo: escopo 
        })

        const emv =
          res?.data?.qrCodePix ||
          res?.data?.[1]?.qrCodePix ||
          res?.qrCodePix ||
          null

        if (!this.proposta.checkout) this.proposta.checkout = {}
        if (escopo === 'entrada') {
          if (!this.proposta.checkout.entrada) this.proposta.checkout.entrada = {}
          this.proposta.checkout.entrada.qrCodePix = emv
        } else {
          if (!this.proposta.checkout.parcelas) this.proposta.checkout.parcelas = {}
          this.proposta.checkout.parcelas.qrCodePix = emv
        }

        window.spinner.emit('close')

        if (!emv) {
          window.toaster.emit('open', { style: 'warning', message: 'Não foi possível gerar o PIX agora', floater: true })
        } else {
          window.toaster.emit('open', { style: 'success', message: 'PIX gerado com sucesso', floater: true })
        }
      } catch (e) {
        window.spinner.emit('close')
        window.toaster.emit('open', { style: 'warning', message: 'Erro ao gerar o PIX. Tente novamente', floater: true })
      }
    },
    fallbackCopy (cod) {
      const el = document.createElement('textarea')
      el.value = cod
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    },
    copiarCodigo (pix) {
      if (!pix) return
      if (!navigator.clipboard) {
        this.fallbackCopy(pix)
      } else {
        navigator.clipboard.writeText(pix).then(() => {
          window.toaster.emit('open', { style: 'success', message: 'Código PIX copiado com sucesso', floater: true })
        }, () => {
          window.toaster.emit('open', { style: 'success', message: 'Ops. Talvez não tenha sido possível copiar o código PIX', floater: true })
          this.fallbackCopy(pix)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .pageInner {
    padding: $hmg_large;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    height: 100%;

    >header{
      color: $preto-2;
      text-align: center;
      margin-top: 0 $hmg_large $hmg_large;

      h1 {
        font-size: 2rem;
      }
    }

    >div {
      color: $preto-2;
      margin-top: $hmg_mid;

      h5 {
        font-weight: normal;
      }

      >div {
        > h5 {
          margin-top: $hmg_mid;
          text-align: center;
        }
        header {
          padding: $hmg_mid 0;
          text-align: center;
          max-width: 80%;
          margin: auto;

          h4 {
            margin: 0 0 $mg_mini 0;
            width: 100%;
          }
          p {
            margin: 0;
            line-height: 1.1;
          }
        } 
      }
    }

    .parcelas {
      margin-top: $hmg_mid;
    }
    .pix-wrap {
      .qr {
        margin: auto;
        padding: 0; border-radius: $border-radius;
        background-color: $color-secondary;
        width: 240px; height: 240px;
        display: flex; align-items: center;
        flex-direction: column; justify-content: center;
        overflow: hidden;
      }

      .codeWrap {
        display: block;
        padding: $hmg_mid; border-radius: $border-radius;
        background-color: $color-secondary;
        word-break: break-all;
        margin: $mg_mini auto;
        max-width: 240px;
      }

      >p {
        display: block; margin-bottom: $hmg_mid;
        max-width: 80%; margin: auto;
        text-align: center;
        margin-top: $mg_mini; line-height: 1.1;
      }
    }
  }
  
</style>